<template>
    <renderless-search
        v-bind="$props"
        v-on="$listeners"
        v-slot="{ results, typing, reset }"
    >
        <div 
            class="flex flex-col md:flex-row-reverse md:justify-end md:items-center max-w-input md:max-w-auto"
            v-click-outside="reset"
        >
            <slot
                name="next-to-search"
                v-bind="{ results, typing, reset }"
            />
            <div class="relative mt-2 md:mt-0 md:mr-2 flex-auto">
                <input
                    type="text"
                    :class="inputClasses"
                    :placeholder="$t('components.meilisearch.search.placeholder')"
                    v-on="typing.on"
                    v-bind="typing.bind"
                />
                <ul
                    class="absolute z-10 top-full max-h-60 overflow-y-auto left-0 right-0 rounded-b shadow p-1 bg-white"
                    v-if="results.having"
                >
                    <li
                        v-for="result in results.all" 
                        :key="result.id"
                    >
                        <slot
                            name="result" 
                            v-bind="{
                                result: result,
                                select: () => results.select(result),
                                isHighlighted: results.isHighlighted(result),
                                displayed: displayBy(result)
                            }"
                        >
                            <search-result
                                :result="result"
                                :select="() => results.select(result)"
                                :is-highlighted="results.isHighlighted(result)"
                                :displayed="displayBy(result)"
                            />
                        </slot>
                    </li> 
                </ul>
            </div>
        </div>
    </renderless-search>
</template>

<script>
import RenderlessSearch from "./RenderlessSearch.vue";
import SearchResult from "./SearchResult.vue";
import setup from "../../../setup";
import mixin from "./mixin"

export default {
    components: { RenderlessSearch, SearchResult },
    props: { ...mixin.props },
    methods: {},
    computed: {
        buttonColor() {
            return setup.css.button.color.gray;
        },
        inputClasses() {
            return setup.css.form.input;
        }
    }
}
</script>